import clsxm from '@/lib/clsxm';

import { CardStylesClassNames } from '@/components/card';
import HygraphImage, { HygraphImageProps } from '@/components/hygraph-image';
import HygraphRichText, {
  HygraphRichTextProps,
} from '@/components/hygraph-rich-text';
import Typography from '@/components/typography';

import { CardStyle } from '@/enums/card-style';

export type QuoteCardProps = {
  quote?: HygraphRichTextProps;
  authorImage?: HygraphImageProps;
  authorName: string;
  jobTitle?: string;
};

export default function QuoteCard({
  quote,
  authorImage,
  authorName,
  jobTitle,
}: QuoteCardProps) {
  return (
    <div
      className={clsxm(
        'flex flex-col bg-background px-5 pb-6 pt-12 md:px-20 md:pb-16 md:pt-16',
        CardStylesClassNames[CardStyle.WHITE_WITH_BORDER]
      )}
    >
      <Typography.Subtitle1 className='w-1 text-[140px] leading-[44px] text-primary'>
        &ldquo;
      </Typography.Subtitle1>

      {quote?.content && <HygraphRichText content={quote?.content} />}

      <div className='flex flex-row items-center gap-4'>
        {!!authorImage && (
          <HygraphImage {...authorImage} imgClassName='h-20 w-fit md:h-16' />
        )}

        <div className='flex flex-1 flex-col '>
          <Typography.Body1 weight='bold'>{authorName}</Typography.Body1>
          {jobTitle && <Typography.Body1>{jobTitle}</Typography.Body1>}
        </div>
      </div>
    </div>
  );
}
